import { BASE_URL } from 'constants/http'

import ServiceBase from 'services/ServiceBase'

import { AiConversationBody } from './constants'

class AiApiClient extends ServiceBase {
  get = (body: AiConversationBody) => this.request({
    baseUrl: BASE_URL.AI,
    body,
    method: 'POST',
    path: '/api/conversation',
  })
}

export default AiApiClient
